// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "compiled-css" + "." + "baa3fce5414d28abbd7d" + ".css";
};